import { Auth } from 'aws-amplify';

const baseURL = import.meta.env.VITE_APP_ACCOUNTS_APP_RUNNER_BASE_URL;
// const baseURL = 'http://localhost:3001/api';

async function getToken() {
  const currentSession = await Auth.currentSession();
  const { idToken } = currentSession;
  return idToken.jwtToken;
}

export async function getAPI(params) {
  const urlParams = new URLSearchParams(params);
  const urlWithParams = `${baseURL}/pageAlerts/page?${urlParams.toString()}`;
  const token = await getToken();
  const response = await fetch(urlWithParams, {
    headers: {
      'x-auth-token': token
    }
  });
  return response.json();
}